import { Button, EmptyState } from "@similarweb/ui-components";

import { browserUtils } from "app/services/fetchService/browserUtils";
import { useTranslation } from "pro-features/components/WithTranslation";

import { AlertPageContainer } from "../../ui/alert-page-container";

const CtaButton = () => {
    const translate = useTranslation();
    const handleOnClick = () => {
        browserUtils.reloadPage();
    };
    return <Button onClick={handleOnClick}>{translate("forms.buttons.reload")}</Button>;
};

export const ErrorCampaignState = () => {
    const translate = useTranslation();
    return (
        <AlertPageContainer>
            <EmptyState
                title={translate("error.boundary.title")}
                subtitle={translate("error.boundary.subtitle")}
                CtaButtons={CtaButton}
                iconName={"no-data-tree"}
            />
        </AlertPageContainer>
    );
};
